// =================================================================
// Store: Monitoring slice (PSD §9.1.5 / TODO Task 2.8)
// =================================================================
import type { StateCreator } from 'zustand';
import type { DurationTier, MonitoringSchedule } from '@/types';
import { computeMonitoringSchedule } from '@/engine';
import type { StoreState, MonitoringSlice } from './types';

export const createMonitoringSlice: StateCreator<StoreState, [], [], MonitoringSlice> = (set, get) => ({
  monitoring: null,

  computeMonitoring: () => {
    const state = get();
    if (!state.renal) return;
    const schedule = computeMonitoringSchedule(
      state.strategyConfig,
      state.renal,
      state.safety,
      state.strategyConfig.infusionDurationMin,
    );
    set({ monitoring: schedule });
  },

  setDurationTier: (day) => {
    const escalation: DurationTier[] = [
      { dayRange: [1, 5], scrBunFrequencyDays: 3, note: 'Initial therapy — routine monitoring.' },
      { dayRange: [6, 7], scrBunFrequencyDays: 2, note: 'Beyond 5 days — increase frequency.' },
      { dayRange: [8, 14], scrBunFrequencyDays: 1, note: 'Prolonged therapy — daily SCr/BUN.' },
    ];
    const tier = escalation.find((t) => day >= t.dayRange[0] && day <= t.dayRange[1]) ?? escalation[0];
    set((state) => {
      const monitoring: MonitoringSchedule | null = state.monitoring
        ? { ...state.monitoring, durationTierEscalation: escalation, scrBunFrequencyDays: tier.scrBunFrequencyDays, scrBunFrequencyReason: tier.note }
        : null;
      return { monitoring };
    });
  },
});
